module.exports = __webpack_public_path__ + "img/header/j4u-watermark.svg";